import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { checkboxData } from './checkboxData';
import './style.css';
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { decoratorTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const DecoratorsTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false);
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(`${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = res.data.data;
            const details = data[0].details;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        getSingleDocumentHandler();
    }, [merchant_id, token]);

    const workingSinceOption = checkboxData.workSinceOption;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const planningTypeOption = checkboxData.planningTypeDecor;

    const formik = useFormik({
        initialValues: {
            indoorBudget: Math.floor(merchant?.indoorBudget * currency.value) || '',
            outdoorBudget: Math.floor(merchant?.outdoorBudget * currency.value) || '',
            homeFunction: Math.floor(merchant?.homeFunction * currency.value) || '',
            workingSince: merchant?.workingSince || [],
            planningType: merchant?.planningType || [],
            areaOfWork: merchant?.areaOfWork || [],
        },
        validationSchema: decoratorTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: {
                        ...values,
                        indoorBudget: Math.floor(values.indoorBudget * currency.country_value),
                        outdoorBudget: Math.floor(values.outdoorBudget * currency.country_value),
                        homeFunction: Math.floor(values.homeFunction * currency.country_value)
                    },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header text-white text-center' style={{ backgroundColor: '#085f9a' }}>
                                <h5>{language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <div className='table-responsive'>
                                            <table className='table text-center'>
                                                <tbody className='ttk_preview'>
                                                    <tr style={{ color: '#41B0FA' }}>
                                                        <th>Working Since</th>
                                                        <th>Starting Indoor Budget</th>
                                                        <th>Starting Outdoor Budget</th>
                                                        <th>Starting Decor Price (Home Function)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {merchant.workingSince?.map((item, index) => (
                                                                <p key={index}>{item.value}</p>
                                                            ))}
                                                        </td>
                                                        <td>
                                                            <NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.indoorBudget
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            />
                                                        </td>
                                                        <td>
                                                            <NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.outdoorBudget
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            />
                                                        </td>
                                                        <td>

                                                            <NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.homeFunction
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr style={{ color: '#41B0FA' }}>
                                                        <th>Planning Type</th>
                                                        <th>Area of Working</th>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {merchant.planningType?.map((item, index) => (
                                                                <span key={index}>
                                                                    <i className='fa fa-check text-success' /> {item.value}{' '}
                                                                </span>
                                                            ))}
                                                        </td>
                                                        <td>
                                                            {merchant.areaOfWork?.map((item, index) => (
                                                                <span key={index}>
                                                                    <i className='fa fa-check text-success' /> {item.value}{' '}
                                                                </span>
                                                            ))}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                                <center>
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }}
                                        onClick={() => setTtkEditMode(!ttkEditMode)}>
                                        {merchant ? 'Make Changes' : 'Tell me more about yourself'}
                                    </button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <label>Working Since <span className='text-danger'>*</span></label>
                                                    <Select
                                                        isMulti
                                                        options={workingSinceOption}
                                                        value={formik.values.workingSince}
                                                        onChange={(val) => formik.setFieldValue('workingSince', val)}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.workingSince && formik.errors.workingSince && (
                                                        <div className="text-danger">{formik.errors.workingSince}</div>
                                                    )}
                                                </div>
                                                <div className='col-md-6'>
                                                    <label>Area of Working <span className='text-danger'>*</span></label>
                                                    <Select
                                                        isMulti
                                                        options={areaOfWorkingOption}
                                                        value={formik.values.areaOfWork}
                                                        onChange={(val) => formik.setFieldValue('areaOfWork', val)}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.areaOfWork && formik.errors.areaOfWork && (
                                                        <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                    )}
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Indoor Budget</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="indoorBudget"
                                                            value={formik.values.indoorBudget}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.indoorBudget && formik.errors.indoorBudget ? (
                                                        <div className="text-danger">{formik.errors.indoorBudget}</div>
                                                    ) : null}
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Outdoor Budget</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="outdoorBudget"
                                                            value={formik.values.outdoorBudget}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.outdoorBudget && formik.errors.outdoorBudget ? (
                                                        <div className="text-danger">{formik.errors.outdoorBudget}</div>
                                                    ) : null}
                                                </div>

                                                  <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Decor Price (Home Function)<span className='text-danger'>*</span></label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="homeFunction"
                                                            value={formik.values.homeFunction}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.homeFunction && formik.errors.homeFunction ? (
                                                        <div className="text-danger">{formik.errors.homeFunction}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <label>Planning Type<span className='text-danger'>*</span></label>
                                                    <Select
                                                        isMulti
                                                        options={planningTypeOption}
                                                        value={formik.values.planningType}
                                                        onChange={(val) => formik.setFieldValue('planningType', val)}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.planningType && formik.errors.planningType && (
                                                        <div className="text-danger">{formik.errors.planningType}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='form-group mt-3'>
                                                <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }}>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DecoratorsTTK;